import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Work from "./components/Work";
import WorkAlpha from "./components/WorkAlpha";
import WorkPlaceholder from "./components/WorkPlaceholder";

function App() {
  return (
    <div className="bg-neutral-900">
      <Navbar />
      <Home />
      <About />
      <Work />
      {/* <WorkPlaceholder /> */}
      {/* <WorkAlpha /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
